import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19v.01","key":"svg-0"}],["path",{"d":"M12 15v-3m0 -4v-3","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconExclamationMarkOff = createReactComponent('outline', 'exclamation-mark-off', 'ExclamationMarkOff', __iconNode);

export default IconExclamationMarkOff;